export enum Statistic2ReportType {
    UserLogins = 1,
    ReadRating = 2,
    FileViews = 3,
}

export enum Statistic2UserSelectionType {
    EveryOne = 1,
    Areas = 2,
    BusinessUnits = 3,
    Users = 4,
    Roles = 5,
}

export enum Statistic2ObjectSelectionType {
    SelectedItems = 1,
    SelectedTags = 2,
    AllItems = 3,
}

export enum Statistic2TimePeriod {
    LastWeek = 1,
    LastMonth = 2,
    LastYear = 3,
    Custom = 4,
}

export enum Statistic2ResultsPerType {
    Area = 1,
    Unit = 2,
    User = 3,
    Object = 4,
    Detailed = 5,
    File = 6,
    NoGroping = 100,
}

export enum Statistic2DataRepresentationType {
    Number = 0,
    Percentage = 1,
}

export enum Statistic2DisplayType {
    BarChart = 1,
    PieChart = 2,
    LineGraph = 3,
    List = 4,
}
